var map = {
	"./en-us.json": [
		"e3b5"
	],
	"./th-th.json": [
		"2c2c",
		"lang-th-th-json"
	],
	"./vi-vn.json": [
		"f563",
		"lang-vi-vn-json"
	],
	"./zh-cn.json": [
		"2c61",
		"lang-zh-cn-json"
	],
	"./zh-tw.json": [
		"cb6e",
		"lang-zh-tw-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;